import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidebarService {
  private detectionSidebarOpenSubject = new BehaviorSubject<boolean>(false);

  constructor() {}

  public get detectionSidebarOpen$(): Observable<boolean> {
    return this.detectionSidebarOpenSubject.asObservable();
  }

  public setDetectionSidebarOpen(isOpen: boolean) {
    this.detectionSidebarOpenSubject.next(isOpen);
  }
}
